import axios from 'axios';
import { apiURL } from 'utils/config';
import { getRealLocale } from 'utils/helpers';

const url = apiURL;

export const getBlogCategory = (locale, page = 0) => {
  return axios({
    url: `${url}/${getRealLocale(locale)}/api/v1/blog-category`,
    method: 'GET',
  });
};

export const getBlogListing = (locale,  categoryId, page) => {
  return axios({
    url: `${url}/${getRealLocale(locale)}/api/v1/blog`,
    method: 'GET',
    params: { page, categoryId },
  });
};

export const getSingleBlog = (locale, blogId) => {
  return axios({
    url: `${url}/${getRealLocale(locale)}/api/v1/blog/${blogId}`,
    method: 'GET',
  });
};

export const getPopular = (locale) => {
  return axios({
    url: `${url}/${locale}/api/v1/blog-popular`,
    method: 'GET',
  });
};

export const setBlogView = (locale, blogId) => {
  return axios({
    url: `${url}/${getRealLocale(locale)}/api/v1/statistics`,
    method: 'POST',
    data: { id: blogId },
  });
};
